import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { CustomProvider } from "./types";

export const useProviders = ({
  userToken,
  enabled = true,
}: {
  userToken: string;
  enabled?: boolean;
}) => {
  const { workspaceId } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);

  const url = new URL(ENDPOINTS.providers(workspaceId!));
  url.searchParams.set("page", page.toString());
  url.searchParams.set("per_page", pageSize.toString());

  const { data, isLoading } = useQuery({
    queryKey: ["providers", workspaceId],
    queryFn: () =>
      fetch(url.toString(), {
        headers: jsonAuthHeaders(userToken!),
        method: "GET",
      }).then((res) => handleResponse(res)),
    enabled,
  });

  const customProviders = data?.providers.filter(
    (provider: CustomProvider) => provider.workspace_id === Number(workspaceId),
  );

  return {
    data: data?.providers,
    customProviders,
    isLoading,
    page,
    setPage,
    pageSize,
    setPageSize,
  };
};
